import { styled } from "@mui/material/styles";
import { Box, List, ListSubheader, Stack } from "@mui/material";

export const ResultList = styled(Box)({
    marginBottom: "16px",
});

export const BoxModalContent = styled(Box)({
    width: "100%",
    height: "100%",
    backgroundColor: "var(--community-color-snow-white)",
    borderRadius: 0,
    padding: 0,
    overflow: "hidden",
});

export const ListSearchResultsWrapper = styled(List)({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 0,
});

export const ListContainer = styled("div")({
    overflowY: "auto",
    height: "100%",
    paddingBottom: "16px",
});

export const StackSearchContainer = styled(Stack)({
    alignItems: "center",
    width: "100%",
    display: "flex",
});

export const BoxSearchWrapper = styled(Box)({
    width: "100%",
});

export const BoxButtonWrapper = styled(Box)({
    padding: "12px 0px 12px 16px",
});

export const BoxSearchSubText = styled(Box)({
    margin: "0 16px 16px 16px",
    fontSize: "16px",
    fontWeight: 700,
    alignItems: "flex-start",
    color: "var(--community-color-secondary-text)",
});

export const GroupSearchNoResultsSubtitle = styled(Box)({
    margin: "0 16px 16px 16px",
    alignItems: "flex-start",
    fontSize: "16px",
    color: "var(--community-color-primary-text)",
});

export const ListSubHeaderWrapper = styled(ListSubheader)<{
    component: string;
}>({
    zIndex: "2",
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    lineHeight: "unset",
    width: "100%",
    padding: "16px",
});

export const ButtonCancel = styled("span")({
    color: "var(--community-color-primary-text)",
    textTransform: "none",
    fontWeight: "400",
    cursor: "pointer",
});

export const CommunityCircularProgressWrapper = styled(Stack)({
    flexDirection: "row",
    justifyContent: "center",
    height: "60px",
});
